module.exports = __webpack_public_path__ + "img/Mask Group 2919@2x.52819624.png";